import React from 'react';
import './MissionVision.css';
import missionImage from '../../../../assets/background.webp';
import visionImage from '../../../../assets/background3.webp';
import aboutImage from '../../../../assets/background7.webp';
import { useLanguage } from '../../../../context/LanguageContext';
import translations from '../../../../translations';

const MissionVision = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section className="mission-vision" id="mission-vision">
      <div className="container">
        <div className="mission-vision__content">
          <div className="mission-vision__header">
            <h2 className="mission-vision__title">{t.missionVisionTitle}</h2>
            <div className="mission-vision__divider"></div>
          </div>

          {/* About Row: Text Left, Image Right */}
          <div className="mission-vision__row mission-vision__row--reverse">
            <div className="mission-vision__text-container">
              <h3 className="mission-vision__text-title">{t.aboutCompanyTitle}</h3>
              <p className="mission-vision__text-description">{t.aboutCompanyDescription}</p>
            </div>
            <div className="mission-vision__image-container">
              <img
                src={aboutImage}
                alt="About Us"
                className="mission-vision__image"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>

          {/* Mission Row: Image Left, Text Right */}
          <div className="mission-vision__row">
            <div className="mission-vision__image-container">
              <img
                src={missionImage}
                alt="Mission"
                className="mission-vision__image"
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="mission-vision__text-container">
              <h3 className="mission-vision__text-title">{t.missionTitle}</h3>
              <p className="mission-vision__text-description">
                {language === 'ar' ?
                  'تقديم احترافية استثنائية ودقة وتنفيذ فعال لأكثر مشاريع البناء طموحاً في المملكة العربية السعودية، دعماً لرؤية المملكة 2030.' :
                  t.missionDescription
                }
              </p>
            </div>
          </div>

          {/* Vision Row: Text Left, Image Right */}
          <div className="mission-vision__row mission-vision__row--reverse">
            <div className="mission-vision__text-container">
              <h3 className="mission-vision__text-title">{t.visionTitle}</h3>
              <p className="mission-vision__text-description">{t.visionDescription}</p>
            </div>
            <div className="mission-vision__image-container">
              <img
                src={visionImage}
                alt="Vision"
                className="mission-vision__image"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionVision; 